import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Moment from 'moment'

import RaisedButton from 'material-ui/RaisedButton'
import SelectField from 'material-ui/SelectField'
import Colors from 'material-ui/styles/colors'
import AutoComplete from 'material-ui/AutoComplete';
import MenuItem from 'material-ui/MenuItem';

import newProjectActions from 'actions/newProjectActions'
import dataActions from 'actions/dataActions'

import {  propertiesExtended } from 'selectors/newProject'
import {  templates, managers } from 'selectors/entities'
import { doc, dirtyRead } from 'selectors/common'
import { sort } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		...state
	  , project: doc(state, props.id)
	  ,	taskTemplates: templates(state)
	  , managers: managers(state)
	  , properties: propertiesExtended(state)
	})
)

export class NewProjectForm extends Component {
	state = {
    property: '',
  };
	handleUpdateInput = (searchText) => {
    this.setState({
      property: searchText,
    });
  };
	componentDidMount(props){
		if (!this.props.project.propertyID) return;
		this.setState({
      property:  this.props.properties[this.props.project.propertyID].alias,
    });
	}
  render(){
		let { props } = this
		let { taskTemplates, managers, properties } = props
		let newProjectID = props.id
		return(
				<div>
			      <div style={{padding: "0 60px"}}>
			        <div>
						<SelectField
						  floatingLabelText={(props.project.templateID)?"Project template":"Choose project template"}
		                  value={(props.project.templateID)? props.project.templateID : ""}
		                  onChange={
							  (evt, id, value) => props.STAGE({_id: newProjectID, templateID: value})
						  }
		                  fullWidth={true}
		                  style={{verticalAlign: 'middle'}}
		                >
							{R.values(sort(taskTemplates, "name")).filter(x => x.title).map((tmpl, indx) => (
									<MenuItem
										key={`${tmpl._id}-manager-${Math.random()}`}
										primaryText={tmpl.title}
										value={tmpl._id}
									/>
								)
							)}
		                </SelectField>
			            <AutoComplete
									  style={{marginTop: "24px", marginBottom: "24px"}}
									  floatingLabelText={(this.state.property)?this.state.property:"Choose property by address, tenant name or phone"}
			              filter={AutoComplete.caseInsensitiveFilter}
			              openOnFocus={true}
			              key={'property-chooser'}
										searchText={this.state.property}
										onUpdateInput={this.handleUpdateInput}
			              onNewRequest={(obj) => props.STAGE({_id: newProjectID, propertyID: obj.value.props.value})}
			              fullWidth={true}
						  			disabled={!R.keys(properties).length}
			              className={`auto-complete-field ${(!R.keys(properties).length)? 'wait-cursor' : ''}`}
			              menuStyle={{maxHeight: '300px', overflowY: 'scroll'}}
			              dataSource={[
							  ...[{
								   text: "All",
								   value: (
									 <MenuItem
									   key={`-6555+65+56+5-property`}
									   primaryText="All"
									   value={"All"}
									 />
								   )
								}]
								,...(R.keys(properties).length)?
									R.values(sort(R.filter(property=> !property.dateTill , properties), "alias")).map((property, indx) => ({
											text:
												property.alias
												+ ' '
												+ property.address
												+ ' '
												+ ((!!props.data[property.leaseID]
													&& props.data[property.leaseID].tenantID
													&& props.data[props.data[property.leaseID].tenantID]
													&& props.data[props.data[property.leaseID].tenantID].phoneNumber
												)?
													`${props.data[props.data[property.leaseID].tenantID].phoneNumber.replace(/\D/g, '')} ${props.data[props.data[property.leaseID].tenantID].tenant || (props.data[props.data[property.leaseID].tenantID].firstName + ' ' + props.data[props.data[property.leaseID].tenantID].lastName)}`
													: ' ')
												+ ' ',
											value: (
												<MenuItem
													key={`${property._id}-property-${Math.random()}`}
													primaryText={property.alias}
													value={property._id}
												/>
											)
										}
									))
			                      : ["Pending..."]
						]}
			            />
						<SelectField
						  floatingLabelText={(props.project.ownerID)?"Manager":"Choose Project Manager"}
		                  value={(props.project.ownerID)? props.project.ownerID : ""}
		                  onChange={
							  (evt, id, value) => props.STAGE({_id: newProjectID, ownerID: value})
						  }
		                  fullWidth={true}
		                  style={{verticalAlign: 'middle'}}
		                >
							{R.values(R.filter((mgr) => !mgr.inactive,sort(managers, "name"))).map((manager, indx) => (
									<MenuItem
										key={`${manager._id}-manager-${Math.random()}`}
										primaryText={manager.name}
										value={manager._id}
									/>
								)
							)}
		                </SelectField>
			        </div>
			      </div>
			  </div>
			)
	}
}
export default connect(select, dataActions)(NewProjectForm)



// WEBPACK FOOTER //
// ./src/routes/manager/projectForm/new/index.js